import { IconLayerGray, IconLayers, IconPcLine, IconSecurity } from '@assets/images/icon';
import { IconComputer, IconGuarantee } from '@assets/images/main';
import { IconOsEdgeOff, IconOsEdgeOn, IconOsServerOff, IconOsServerOn, IconOsSwitchOff, IconOsSwitchOn } from '@assets/images/main/icon';
import {
  IconBlueCircle,
  IconBlueCycle,
  IconBlueDevelop,
  IconBlueFigure,
  IconBluePlus,
  IconBluePower,
  IconBlueScan,
  IconBlueShield,
} from '@assets/images/main/icon/blue';
import { osBanner, osDownloadD, osDownloadM, osDownloadT, osLogoDesktop, osLogoMobile, osLogoTablet } from '@assets/images/main/os/bannerImg';
import {
  OsSectionDesktop1,
  OsSectionTablet1,
  OsSectionMobile1,
  OsSectionDesktop2,
  OsSectionTablet2,
  OsSectionMobile2,
  OsSectionDesktop3,
  OsSectionTablet3,
  OsSectionMobile3,
  OsSectionDesktop4,
  OsSectionTablet4,
  OsSectionMobile4,
  OsSectionDesktop5,
  OsSectionTablet5,
  OsSectionMobile5,
  OsSectionDesktop6,
  OsSectionTablet6,
  OsSectionMobile6,
  OsSectionDesktop7,
  OsSectionTablet7,
  OsSectionMobile7,
  OsSectionDesktop8,
  OsSectionTablet8,
  OsSectionMobile8,
  OsSectionDesktop9,
  OsSectionTablet9,
  OsSectionMobile9,
  OsSectionDesktop10,
  OsSectionTablet10,
  OsSectionMobile10,
  OsSectionDesktop11,
  OsSectionTablet11,
  OsSectionMobile11,
  OsSectionDesktop12,
  OsSectionTablet12,
  OsSectionMobile12,
  OsSectionDesktop13,
  OsSectionTablet13,
  OsSectionMobile13,
  OsSectionDesktop14,
  OsSectionTablet14,
  OsSectionMobile14,
  OsSectionDesktop15,
  OsSectionTablet15,
  OsSectionMobile15,
  OsTextImg1,
  OsTextImg2,
  OsTextImg3,
  OsTextImg4,
  OsSectionDesktop16,
  OsSectionTablet16,
  OsSectionMobile16,
  OsSectionDesktop17,
  OsSectionTablet17,
  OsSectionMobile17,
  OsSectionDesktop18,
  OsSectionTablet18,
  OsSectionMobile18,
  OsSectionDesktop19,
  OsSectionTablet19,
  OsSectionMobile19,
  OsSectionDesktop20,
  OsSectionTablet20,
  OsSectionMobile20,
} from '@assets/images/main/os/section';
import { screenViewOs1, screenViewOs2, screenViewOs3, screenViewOs4, screenViewOs5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgDashboardLine } from '@assets/images/icon/svg/dashboard-line.svg';
import { ReactComponent as SvgAppsLine } from '@assets/images/icon/svg/apps-line.svg';
import { ReactComponent as SvgMonitorLine } from '@assets/images/icon/svg/monitor-line.svg';
import { ReactComponent as SvgUsersLine } from '@assets/images/icon/svg/users-line.svg';
import { ReactComponent as SvgBellLine } from '@assets/images/icon/svg/bell-line.svg';

export default {
  bannerData: [
    {
      icon: IconOsServerOn,
      iconInv: IconOsServerOff,
      image: '',
      iconText: 'ORBRO Server',
      sub: 'New',
      link: '/vi/os/server',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge RTLS',
      sub: 'New',
      link: '/vi/os/rtls',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/vi/os/ai',
    },
    {
      icon: IconOsSwitchOn,
      iconInv: IconOsSwitchOff,
      image: '',
      iconText: 'L2 Switch',
      sub: 'New',
      link: '/vi/os/switch',
    },
  ],

  title: 'Nhiều không gian và thiết bị đa dạng,<br/>nền tảng số kết nỗi ngay trong tầm mắt',
  desc: 'Với ORBRO OS được tích hợp sẵn trên ORBRO Server, quản lý không gian, thiết bị và người dùng chỉ trong một giao diện.<br/>Kiểm tra thông tin thời gian thực từ bất kỳ đâu và đảm bảo vận hành an toàn.',
  osLogo: {
    desktop: osLogoDesktop,
    tablet: osLogoTablet,
    mobile: osLogoMobile,
  },

  bannerImg: osBanner,
  screenView: {
    title: 'Giao diện tích hợp cho giám sát hiện trường theo thời gian thực',
    data: [
      { icon: SvgDashboardLine, text: 'Màn hình chính bảng điều khiển', img: screenViewOs1 },
      { icon: SvgAppsLine, text: 'Cung cấp giao diện tiện ích', img: screenViewOs2 },
      { icon: SvgMonitorLine, text: 'Hỗ trợ chế độ xem đa phương thức', img: screenViewOs3 },
      { icon: SvgUsersLine, text: 'Quản lý người dùng', img: screenViewOs4 },
      { icon: SvgBellLine, text: 'Quản lý thông báo và lớp phủ', img: screenViewOs5 },
    ],
  },
  section: {
    title: 'ORBRO OS chỉ hoạt động trên<br/>ORBRO Server và ORBRO Edge.',
    desc: 'Tùy theo quy mô và trạng thái môi trường, ORBRO Edge phù hợp cho không gian nhỏ, còn ORBRO Server lý tưởng cho môi trường lớn, cho phép quản lý thống nhất không gian, thiết bị và người dùng trên một giao diện.',
    tag: [
      {
        icon: IconPcLine,
        title: 'Vận hành an toàn 24/7',
        desc: 'Thiết kế phần cứng bền bỉ đảm bảo thực hiện liên tục các tác vụ như định vị hoặc phân tích AI mà không gián đoạn.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật không cần cloud bên ngoài',
        desc: 'Xử lý dữ liệu ngay trong mạng nội bộ hoặc mạng bảo mật, mà không cần gửi lên cloud bên ngoài, giúp bảo vệ thông tin nhạy cảm.',
      },
      {
        icon: IconLayers,
        title: 'Kết nối không giới hạn với thiết bị và cảm biến',
        desc: 'Đảm bảo vận hành ổn định ngay cả khi thêm vào các thiết bị đa dạng như tag theo dõi vị trí không dây, cảm biến, camera và nhiều hơn nữa.',
      },
    ],
    img: {
      desktop: OsSectionDesktop1,
      tablet: OsSectionTablet1,
      mobile: OsSectionMobile1,
    },
  },

  section1: {
    img: OsTextImg1,
    tag: 'Giám sát thời gian thực',
    title: 'Vị trí · Video · Cảm biến,<br/>tất cả trong một giao diện',
    desc: 'Theo dõi tích hợp camera IP/PTZ cùng các cảm biến nhiệt độ, độ ẩm, chất lượng không khí và phát hiện cháy.<br/>Khi phát hiện tình huống bất thường, thông báo đẩy (push notification) sẽ được gửi tức thì để hỗ trợ ứng phó.',
    box: [
      {
        size: 1,
        title: 'Thông báo sự kiện & Giám sát RTLS',
        desc: 'Màn hình giám sát cho phép theo dõi ngay lập tức sự kiện và truy xuất vị trí nhân viên, khách truy cập. Cảnh báo tức thì khi điều kiện bất thường, tăng cường an ninh và xử lý công việc.',
        img: {
          desktop: OsSectionDesktop2,
          tablet: OsSectionTablet2,
          mobile: OsSectionMobile2,
        },
      },
      {
        size: 2,
        title: 'Giám sát camera thời gian thực',
        desc: 'Xem luồng video của các camera đã đăng ký, theo dõi trạng thái, kết nối và thời gian hoạt động. Khi xảy ra lỗi, kiểm tra ngay. Với ORBRO AI, thực hiện RTLS và nhận diện, phát hiện đối tượng thông minh.',
        img: {
          desktop: OsSectionDesktop3,
          tablet: OsSectionTablet3,
          mobile: OsSectionMobile3,
        },
      },
      {
        size: 2,
        title: 'Giám sát cảm biến thời gian thực',
        desc: 'Cảm biến chất lượng không khí thu thập dữ liệu nhiệt độ, độ ẩm, bụi mịn… và hiển thị rõ ràng để xử lý kịp thời. Biểu đồ trực quan và dashboard giúp theo dõi biến động, quản lý vị trí và tình trạng thiết bị tập trung.',
        img: {
          desktop: OsSectionDesktop4,
          tablet: OsSectionTablet4,
          mobile: OsSectionMobile4,
        },
      },
    ],
  },

  section2: {
    img: OsTextImg2,
    tag: 'Quản lý không gian',
    title: 'Chuyển đổi không gian sang kỹ thuật số,<br/>xóa nhòa ranh giới giữa ảo và thực',
    desc: 'Cài đặt thông tin tòa nhà, tầng và xác định vị trí thiết bị để tái hiện không gian thực thành Digital Twin. Ngoài ra, còn có thể tạo nên một môi trường số chính xác và chi tiết hơn bằng cách tải lên các bản vẽ 3D.',
    box: [
      {
        size: 2,
        title: 'Quản lý không gian',
        desc: 'Chỉ với vài thao tác, tải bản vẽ tầng lên, nhập tỷ lệ, tạo bản đồ số đúng kích thước thực. Nhờ đó xác định vị trí chính xác từng khu vực và triển khai camera, cảm biến hiệu quả.',
        img: {
          desktop: OsSectionDesktop5,
          tablet: OsSectionTablet5,
          mobile: OsSectionMobile5,
        },
      },
      {
        size: 2,
        title: 'Quản lý Zone',
        desc: 'Trên bản đồ, định nghĩa vùng cần giám sát (Zone), chọn đối tượng (người, thiết bị, xe…). Tập trung dữ liệu theo khu vực, xem thông tin truy cập, sự kiện để quản lý an ninh và vận hành chuyên nghiệp.',
        img: {
          desktop: OsSectionDesktop6,
          tablet: OsSectionTablet6,
          mobile: OsSectionMobile6,
        },
      },
      {
        size: 1,
        title: 'Bản đồ 3D chi tiết',
        desc: 'Tải file 3D để hiển thị cấu trúc và bố trí chính xác hơn so với bản vẽ 2D. Theo dõi độ cao và vị trí thiết bị trực quan, nâng cao hiệu quả sử dụng không gian và an toàn.',
        img: {
          desktop: OsSectionDesktop7,
          tablet: OsSectionTablet7,
          mobile: OsSectionMobile7,
        },
      },
    ],
  },

  section3: {
    img: OsTextImg3,
    tag: 'Tính năng ứng dụng',
    title: 'Ghi nhận, phân tích,<br/>vận hành thông minh, phản ứng tự động',
    desc: 'Ghi lại và phát lại các tuyến di chuyển để phân tích dữ liệu, hiển thị mô hình di chuyển qua Heatmap, đồng thời xử lý các tình huống khẩn cấp theo quy trình tự động hóa dựa trên SOP.',
    box: [
      {
        size: 1,
        title: 'Heatmap',
        desc: 'Hiển thị heatmap dựa trên dữ liệu RTLS đã lưu, cho biết mật độ di chuyển trong khoảng thời gian chọn. Giúp nắm bắt khu vực đông đúc, tối ưu bố trí, an ninh, marketing.',
        img: {
          desktop: OsSectionDesktop8,
          tablet: OsSectionTablet8,
          mobile: OsSectionMobile8,
        },
      },
      {
        size: 1,
        title: 'Ghi lại (Record)',
        desc: 'Ghi lại dữ liệu vị trí theo thời gian, phát lại di chuyển chi tiết. Hữu ích cho an ninh, an toàn và tối ưu luồng di chuyển.',
        img: {
          desktop: OsSectionDesktop9,
          tablet: OsSectionTablet9,
          mobile: OsSectionMobile9,
        },
      },
      {
        size: 2,
        title: 'Tạo SOP',
        desc: 'Cấu hình quy trình vận hành chuẩn (SOP) theo điều kiện sự kiện: điều kiện, bước xử lý, người phụ trách, gửi SMS… để mọi người thực hiện nhanh chóng, nhất quán.',
        img: {
          desktop: OsSectionDesktop10,
          tablet: OsSectionTablet10,
          mobile: OsSectionMobile10,
        },
      },
      {
        size: 2,
        title: 'Kích hoạt SOP',
        desc: 'Khi SOP được kích hoạt, hiển thị thông tin khu vực, thời gian, điều kiện, hướng dẫn từng bước và chia sẻ tức thì với người phụ trách qua SMS.',
        img: {
          desktop: OsSectionDesktop11,
          tablet: OsSectionTablet11,
          mobile: OsSectionMobile11,
        },
      },
    ],
  },

  section4: {
    img: OsTextImg4,
    tag: 'Cài đặt quản trị',
    title: 'Dễ dàng kiểm soát người dùng,<br/>nhóm và thiết bị tại một nơi.',
    desc: 'Cho phép thêm, chỉnh sửa và xóa tài khoản quản trị/người dùng, nhóm nhận thông báo, cũng như tất cả thiết bị như camera, cảm biến một cách trực quan.',
    box: [
      {
        size: 2,
        title: 'Quản lý người dùng',
        desc: 'Thiết lập và duy trì loại tài khoản, phạm vi quyền và thông tin liên hệ cho từng người dùng.',
        img: {
          desktop: OsSectionDesktop12,
          tablet: OsSectionTablet12,
          mobile: OsSectionMobile12,
        },
      },
      {
        size: 2,
        title: 'Quản lý nhóm',
        desc: 'Phân nhóm người dùng theo phòng ban hoặc đội để vận hành một cách hệ thống.',
        img: {
          desktop: OsSectionDesktop13,
          tablet: OsSectionTablet13,
          mobile: OsSectionMobile13,
        },
      },
      {
        size: 2,
        title: 'Quản lý cảnh báo',
        desc: 'Đặt điều kiện và mức độ cảnh báo cho cảm biến cháy, khí độc, vùng cấm… Gửi thông báo tự động theo mức độ để xử lý ngay.',
        img: {
          desktop: OsSectionDesktop14,
          tablet: OsSectionTablet14,
          mobile: OsSectionMobile14,
        },
      },
      {
        size: 2,
        title: 'Quản lý thiết bị',
        desc: 'Đăng ký và chỉnh sửa camera, cảm biến, tag tập trung. Xem trạng thái, pin và kết nối, thay đổi cấu hình tức thì để tối ưu vận hành.',
        img: {
          desktop: OsSectionDesktop15,
          tablet: OsSectionTablet15,
          mobile: OsSectionMobile15,
        },
      },
    ],
  },

  section5: {
    img: OsTextImg4,
    tag: '',
    title: 'Kết nối không dây, Video, GPS, Kiểm soát truy cập, IoT công nghiệp,<br/>tất cả trên cùng một nền tảng duy nhất',
    desc: 'ORBRO OS tích hợp hỗ trợ tất cả từ theo dõi vị trí, kiểm soát truy cập đến cảm biến IoT công nghiệp trên một nền tảng duy nhất. Hãy khám phá các dòng sản phẩm chi tiết của chúng tôi.',
    box: [
      {
        size: 1,
        title: 'Định vị vị trí qua sóng vô tuyến',
        desc: 'Dựa trên công nghệ truyền thông không dây như BLE, AoA, UWB.',
        img: {
          desktop: OsSectionDesktop16,
          tablet: OsSectionTablet16,
          mobile: OsSectionMobile16,
        },
        link: '/vi/rtls',
      },
      {
        size: 2,
        title: 'Định vị qua video',
        desc: 'Theo dõi đối tượng bằng công nghệ video dựa trên AI',
        img: {
          desktop: OsSectionDesktop17,
          tablet: OsSectionTablet17,
          mobile: OsSectionMobile17,
        },
        link: '/vi/camera',
      },
      {
        size: 2,
        title: 'Định vị ngoài trời',
        desc: 'Theo dõi vị trí phương tiện xe cộ và khu vực ngoài trời',
        img: {
          desktop: OsSectionDesktop18,
          tablet: OsSectionTablet18,
          mobile: OsSectionMobile18,
        },
        link: '/vi/outdoor/gps',
      },
      {
        size: 2,
        title: 'Hệ thống quản lý ra vào',
        desc: 'Kiểm soát ra vào với cửa tự động, nhận diện khuôn mặt, v.v.',
        img: {
          desktop: OsSectionDesktop19,
          tablet: OsSectionTablet19,
          mobile: OsSectionMobile19,
        },
        link: '/vi/access',
      },
      {
        size: 2,
        title: 'IIoT',
        desc: 'Kết nối cảm biến chất lượng không khí, cảm biến khí CO, LoRa Gateway, robot, v.v.',
        img: {
          desktop: OsSectionDesktop20,
          tablet: OsSectionTablet20,
          mobile: OsSectionMobile20,
        },
        link: '/vi/iot/LoRAGateway',
      },
    ],
  },

  downloadSection: {
    title: 'Vận hành an toàn trên mọi nền tảng như <br/>Web · Mobile · Tablet',
    desc: 'ORBRO OS cung cấp giao diện đồng nhất trên trình duyệt PC, ứng dụng iOS, Android và Tablet.',
    ios: 'Tái xuống IOS',
    aos: 'Tải xuống Android',
    img: {
      desktop: osDownloadD,
      tablet: osDownloadT,
      mobile: osDownloadM,
    },
  },
  function: {
    title: 'Các tính năng đa dạng khác',
    box: [
      {
        icon: IconBlueScan,
        title: 'Phân tích và trực quan hóa dữ liệu thời gian thực',
        desc: 'ORBRO OS phân tích và trực quan hóa dữ liệu thu thập được, cung cấp thông tin dễ hiểu cho người dùng. Cho phép khai thác và sử dụng dữ liệu từ Digital Twin theo thời gian thực một cách hiệu quả.',
      },
      {
        icon: IconBlueShield,
        title: 'Bảo mật và quyền riêng tư',
        desc: 'Cung cấp các tính năng bảo mật mạnh mẽ để bảo vệ Digital Twin. Hạn chế truy cập vào thông tin nhạy cảm và ngăn chặn sửa đổi dữ liệu trái phép, giảm thiểu rủi ro bảo mật.',
      },
      {
        icon: IconBlueDevelop,
        title: 'Thân thiện với nhà phát triển',
        desc: 'Được thiết kế để các nhà phát triển dễ dàng sử dụng và mở rộng chức năng digital Twin. Cung cấp API mạnh mẽ và công cụ phát triển, hỗ trợ xây dựng các ứng dụng và dịch vụ mới.',
      },
      {
        icon: IconBlueFigure,
        title: 'Tích hợp trí tuệ nhận tạo AI',
        desc: 'Tích hợp công nghệ AI để quản lý và tối ưu hóa Digital Twin một cách thông minh. Sử dụng thuật toán AI để phân tích dữ liệu, xây dựng mô hình dự đoán, nâng cao hiệu suất hệ thống.',
      },
      {
        icon: IconBluePower,
        title: 'Giám sát môi trường và quản lý năng lượng thông minh',
        desc: 'Tích hợp cảm biến giám sát môi trường để tối ưu hóa tiêu thụ năng lượng. Theo dõi trạng thái môi trường thời gian thực và tự động điều chỉnh hệ thống để tối đa hóa hiệu quả năng lượng.',
      },
      {
        icon: IconBlueCycle,
        title: 'Tự động hóa và điều khiển thông minh',
        desc: 'Dựa trên dữ liệu từ Digital Twin, hệ thống có thể đưa ra các quyết định tự động. Ví dụ, tự động điều khiển thiết bị hoặc thực thi quy trình khi một số điều kiện nhất định được đáp ứng.',
      },
      {
        icon: IconBluePlus,
        title: 'Giao diện tùy chỉnh',
        desc: 'Cung cấp khả năng tùy chỉnh giao diện theo nhu cầu người dùng. Người dùng có thể tự do thiết kế Dashboard hoặc ứng dụng để giám sát và điều khiển Digital Twin.',
      },
      {
        icon: IconBlueCircle,
        title: 'Tính mở rộng hệ sinh thái',
        desc: 'Xây dựng hệ sinh thái cho phép nhà phát triển, doanh nghiệp tạo ra các add-on hoặc plug-in để mở rộng hệ thống. Hỗ trợ cung cấp các giải pháp tùy chỉnh cho nhiều ngành và ứng dụng khác nhau.',
      },
    ],
  },

  faqTitle: 'Câu hỏi thường gặp',

  beacon: {
    index: 4,
  },
  rtls: {
    index: 1,
  },
  camera: {
    index: 2,
  },
  access: {
    index: 3,
  },
  sensor: {
    index: 4,
  },
  integration: {
    index: 1,
  },
};
